<template>
  <profile-image
    :name="name"
    :image="profileImage"
  />
</template>

<script>
import ProfileImage from '@/components/ProfileImage';

export default {
  name: 'TeamAvatar',

  components: {
    ProfileImage,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
  },

  computed: {
    profileImage() {
      return this.team.imageUrl;
    },

    name() {
      return this.team.name;
    },
  },
};
</script>
